import { StaticImport } from "next/dist/shared/lib/get-img-props";
import { useEffect, useState } from "react";

export const useImageErrorHandler = (
  icon: string | StaticImport,
  placeholderIcon: string | StaticImport,
) => {
  const [currentIcon, setCurrentIcon] = useState(icon);

  useEffect(() => {
    setCurrentIcon(icon);
  }, [icon]);

  const handleImageError = () => {
    setCurrentIcon(placeholderIcon);
  };

  return { currentIcon, handleImageError };
};
